import { resolveWithBase } from '@/utils/pathUtils';

export class UIStrings {

    public async getLocaleStrings(locale: string) {
        var finalText;

        var defaultText = await this.LoadLocale("en");
        var lang = locale.substring(0, 2).toLocaleLowerCase()
        // Get the resource strings that match the language.
        switch (lang) {
            case 'en':
                finalText = defaultText;
                break;
            default:
                var localesText = {};
                try {
                    localesText = await this.LoadLocale(lang);
                    finalText = {
                        ...defaultText,
                        ...localesText
                    }
                }
                catch
                {
                    console.log("Could not load locales for " + lang);
                    finalText = defaultText;
                }

                break;
        }
        finalText["~"] = locale;
        return finalText;
    };

    public async LoadLocale(file: string) {
        const localeUrl = resolveWithBase(`locales/${file}.json?v=639294768642061608`);
        var response = await fetch(localeUrl);
        var texts = await response.json();
        return texts
    }

}

export default UIStrings;
